<template>
    <el-dropdown class="layout-user" v-if="isLogin" trigger="click" @command="handleCommand">
        <!-- <span class="el-dropdown-link text-success">
            {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span> -->
        <el-button type="text">
            <span class="layout-user__uname">{{ userName }}</span><i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" >
            <el-dropdown-item command="logout" class="text-error">退出</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
export default {
  name: 'GlLayoutUser',
  componentName: 'GlLayoutUser',
  props: {
    userName: String,
    actives: {
      type: Object,
      default() {
        return {
          logout(store, router) {
            store.dispatch('UserAuth')
            router.push('/login')
          }
        }
      }
    }
  },
  methods: {
    handleCommand(cmd) {
      this.actives[cmd](this.$store, this.$router)
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/User.vue